/* unplugin-vue-components disabled *//* vant-demand-import */
import installComponents from "!../../../plugins/vant-demand-import/installComponents.js"
import VanButton from 'vant/es/button'
import 'vant/es/button/style/less'
import '/Users/noromacpro/work/orale-h5/vant-extra/style-override/button.css'


import { render, staticRenderFns } from "./credit-second-retain-popup.vue.js?vue&type=template&id=bf4268fa!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./credit-second-retain-popup.vue?vue&type=template&id=bf4268fa"
import script from "./credit-second-retain-popup.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./credit-second-retain-popup.vue?vue&type=script&setup=true&lang=js"
export * from "./credit-second-retain-popup.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./credit-second-retain-popup.vue?vue&type=script&setup=true&lang=js"
import style0 from "./credit-second-retain-popup.vue.postcss?vue&type=style&index=0&id=bf4268fa&prod&lang=postcss&module=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./credit-second-retain-popup.vue?vue&type=style&index=0&id=bf4268fa&prod&lang=postcss&module=true"
import style1 from "./credit-second-retain-popup.vue.css?vue&type=style&index=1&id=bf4268fa&prod&lang=css!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./credit-second-retain-popup.vue?vue&type=style&index=1&id=bf4268fa&prod&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports
installComponents(component, {VanButton})
